import React from 'react'

import { formatDate } from './formatDate'

const CVEducation = ({
  studyType,
  area,
  institution,
  startDate,
  endDate,
  gpa,
  courses,
}) => (
  <article>
    <h3>
      {studyType}, {area} - {institution}
    </h3>
    <h4>
      {formatDate(startDate)} - {endDate && formatDate(endDate)}
      {gpa ? [<br />, `GPA: ${gpa}`] : ''}
    </h4>
    {courses && [
      <h4>TOPICS</h4>,
      <ul>{courses.map(course => <li style={{marginBottom: 0}}>{course}</li>)}</ul>,
    ]}
  </article>
)

export default CVEducation



// WEBPACK FOOTER //
// ./src/components/cv/CVEducation.js